import React from 'react';
import {IPresentationMeta} from '../../../../incase-domain/presentation';
import ViewerPresentationLinks from '../../presentationList/presentationLinks/components/ViewerPresentationLinks';

interface IAccessLinksStepProps {
    presentation: IPresentationMeta;
    roomId?: string;
    presenterLinkCode?: string;
}

function AccessLinksStep({presentation, roomId, presenterLinkCode}: IAccessLinksStepProps): JSX.Element {
    return <ViewerPresentationLinks presentation={presentation} open roomId={roomId} presenterLinkCode={presenterLinkCode} />;
}

export default AccessLinksStep;
